export default __webpack_public_path__ + "static/media/logo-white.116d01be.svg";